import { useAuth } from "../context/AuthContext";
import { useAccess } from "../hooks/useAccess";
import { getPublicPlans } from "../config/plans";
import { PRICING_PAGE_ENABLED } from "../config/featureFlags";
import PricingCard from "../components/PricingCard";
import { NotFoundPage } from "../errors/NotFoundPage";
import "../App.css";

export default function PricingPage() {
  const { user } = useAuth();
  const { access } = useAccess();
  const tier = access?.tier ?? "free";
  const accessSource = access?.accessSource ?? "none";
  const isAdminOrOwner = access?.role === "admin" || access?.role === "owner";

  if (!PRICING_PAGE_ENABLED && !isAdminOrOwner) {
    return <NotFoundPage />;
  }

  return (
    <section className="arena-bg">
      <div className="page-heading">
        <h2 className="page-title">Plans &amp; Pricing</h2>
        <p className="page-sub">Pick your plan. Enter the arena.</p>
      </div>
      <div className="battle-cards-grid">
        {getPublicPlans().map((plan) => (
          <PricingCard
            key={plan.id}
            plan={plan}
            authenticated={Boolean(user)}
            tier={tier}
            accessSource={accessSource}
          />
        ))}
      </div>
    </section>
  );
}
